import { message } from 'antd';
import React from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Loading from 'components/atoms/Loading';
import useDidMount from 'hooks/useDidMount';
import { loginSocialService } from 'services/auth';
import { getLocalStorage, setAccessToken, setRefreshToken } from 'services/common/storage';
import { getProfileAction } from 'store/auth';
import { useAppDispatch } from 'store/hooks';
import { LOCAL_STORAGE, ROUTE_PATHS } from 'utils/constants';

const LoginMicrosoft: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const code = searchParams.get('code');
  const state = searchParams.get('state');

  const { mutate: handleLoginSocial, isLoading } = useMutation(['loginSocialMutate'], loginSocialService, {
    onSuccess(data) {
      const { accessToken, refreshToken } = data;
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);
      dispatch(getProfileAction())
        .unwrap()
        .then((res) => {
          if (res) {
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_STATE);
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_UUID);
            navigate(ROUTE_PATHS.AGENT);
          }
        });
    },
    onError() {
      navigate(ROUTE_PATHS.LOGIN);
      message.error('Login fail! Please double check.');
    },
  });

  useDidMount(() => {
    if (code) {
      const stateLocal = getLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_STATE);
      const uuid = getLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_UUID);
      if (stateLocal === state && uuid) {
        handleLoginSocial({
          payload: {
            code,
            redirectUri: `${window.location.origin}${ROUTE_PATHS.LOGIN_MICROSOFT}`,
            uuid,
          },
          provider: 'microsoft',
        });
      }
    }
  });

  return <div className="p-loginGoogle">{isLoading && <Loading width={50} variant="fullscreen" />}</div>;
};

export default LoginMicrosoft;
